var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"consent-settings",attrs:{"squared":"","variant":"outline"},on:{"click":_vm.consentButton}},[_c('b-icon-gear')],1)}
var staticRenderFns = []

export { render, staticRenderFns }